import { useRefreshTick } from "../../lib/useAutoRefresh";
import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { api, apiErr } from "../../lib/api";
import { money } from "../../lib/format";
import { toast } from "sonner";
import { Card, Label, Loading, fmtDate } from "./MeHome";

const API = process.env.REACT_APP_BACKEND_URL;

export default function MePay() {
  const [slips, setSlips] = useState(null);
  const [open, setOpen] = useState(null);
  const tick = useRefreshTick();
  useEffect(() => { api.get("/me/payslips").then((r) => setSlips(r.data)).catch((e) => toast.error(apiErr(e))); }, [tick]);
  if (!slips) return <Loading />;
  return (
    <div className="space-y-5" data-testid="me-pay">
      <div><Label>Pay</Label><h1 className="text-4xl font-extrabold tracking-tight mt-2 text-slate-900">Pay stubs</h1><p className="text-sm text-slate-500 mt-2">Only finalized pay runs appear here.</p></div>
      {slips.length === 0 && <div className="emp-empty">No pay stubs yet.</div>}
      {slips.map((p) => (
        <Card key={p.payslip_id} data-testid={`me-payslip-${p.payslip_id}`} className="p-0">
          <button onClick={() => setOpen(open === p.payslip_id ? null : p.payslip_id)} className="w-full text-left p-6 flex items-center justify-between gap-3 active:scale-[0.98] transition-transform rounded-3xl">
            <div><div className="font-bold text-slate-900">{fmtDate(p.pay_date)}</div><div className="text-sm text-slate-500 mt-0.5">{p.period_start && p.period_end ? `${fmtDate(p.period_start)} – ${fmtDate(p.period_end)}` : p.run_number}</div></div>
            <div className="text-right"><div className="emp-num text-2xl font-extrabold text-slate-900">{money(p.net_pay)}</div><div className="emp-label">net pay</div></div>
          </button>
          {p.deposit && (
            <div data-testid={`me-deposit-${p.payslip_id}`} className={`mx-6 -mt-2 mb-4 text-xs font-medium ${p.deposit.status === "settled" ? "text-emerald-700" : "text-amber-700"}`}>
              {p.deposit.status === "settled" ? `Paid by direct deposit ····${p.deposit.last4} on ${fmtDate(p.deposit.settle_date)}` : `Direct deposit ····${p.deposit.last4} on its way`}
            </div>
          )}
          {open === p.payslip_id && (
            <div className="border-t border-slate-100 p-6 pt-4 text-sm">
              <div className="grid grid-cols-2 gap-y-2">
                {[["Gross", p.gross], ["Income tax", p.income_tax], ["CPP", (p.cpp || 0) + (p.cpp2 || 0)], ["EI", p.ei]].map(([k, v]) => <div key={k} className="contents"><span className="text-slate-500">{k}</span><span className="text-right emp-num font-semibold">{money(v)}</span></div>)}
                {p.hours ? <div className="contents"><span className="text-slate-500">Hours</span><span className="text-right emp-num font-semibold">{p.hours}</span></div> : null}
              </div>
              <a data-testid={`me-payslip-pdf-${p.payslip_id}`} href={`${API}/api/me/payslips/${p.payslip_id}.pdf`} target="_blank" rel="noreferrer" className="emp-btn-sm mt-5"><FileDown className="h-4 w-4" /> Download PDF</a>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}
